import React, { useCallback, useMemo, useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import {
  Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import { Form, Container, Row, Col } from "react-bootstrap";
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import { Delete, Print, Download, List } from '@mui/icons-material';
import Modal from 'react-bootstrap/Modal';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import * as AuthVerify from '../../lib/common';

const CustomTable = ({contractData,updateDataList,catalogDetails}) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [eData, setEData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [eIsError, setEIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [eIsLoading, setEIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [eIsRefetching, setEIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [eRowCount, setERowCount] = useState(0);
  const [emShow, setEmShow] = useState(false);
  const [dmShow, setDmShow] = useState(false);
  const selectedMatnum = useRef(false);
  const showModal = useRef(false);

  const [editPermission, setEditPermission] = useState(false);

  const [columnFilters, setColumnFilters] = useState([]);
  const [eColumnFilters, setEColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    sellingprice: 'equals',
    matname: 'contains',
    contractprice: 'equals',
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [eGlobalFilter, setEGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [eSorting, setESorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const eTableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });
  const [ePagination, setEPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  useEffect(async () => {
    setEditPermission(!AuthVerify.getPermissions("Catalog")?.edit);
  }, [searchParams])

  const findFilterCondition = (name) => {
    var condition = '';
    if (columnFilterFns[name]) {
      condition = columnFilterFns[name];
    }
    // if(condition==''){
    //   condition = initialColumnFiltersFns[name];
    // }
    return condition;
  }

  const fetchDataFromAPI = async (reset = false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    let filterQuery = '';
    let sorterQuery = '';

    if (!reset) {
      if (columnFilters.length > 0) {
        columnFilters.forEach(element => {
          filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if (sorting.length > 0) {
        sorting.forEach(element => {
          sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
        });
      }
    } else {
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    const user = AuthVerify.getUser();
    const catalognum = searchParams.get("catalognum")
    let url = `/corporate/catalog/${user.arnum}/${catalognum}/${contractData?.current?'newcontractitem':'new'}?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.items.items ?? []);
          setRowCount(response.data?.data.items.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };

    // Add New Catalog Item
    // https://devb2b.bizpoint-intl.com:3082/api/corporate/catalog/:arnum/:catalog/newitem
    const addNewCartItemsFromList = async (rows) => {
      const arnum=AuthVerify.getUser().arnum;
      const catalognum=catalogDetails.catalognum;
      var data={item: []}
      rows.forEach(item=>{
          data.item.push({matnum:item.original.matnum});
      })
      await Axios.post(`/corporate/catalog/${arnum}/${catalognum}/newitem`,data)
      .then(function (response) {
          if (response && response.data?.data?.items) {
              updateDataList(response);
              setEmShow(false);
              toast.success('Item added successfully', {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 3000,
                  transition: Slide,
              });
          }
          else {
            toast.error(response.statusText??"Data fetching failed !", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
              transition: Slide,
            });
          }
      })
      .catch(function (error) {
        navigate('/');
      });
  };


  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.imageurl,
        id: 'imageurl',
        enableColumnFilter: false,
        enableSorting: false,
        enableColumnFilterModes: false,
        header: 'Product',
        enableEditing: false,
        size: 50,
        Cell: ({ cell, row }) => (
          <a href="#">
            <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(cell.getValue())} alt="Product" />
          </a>
          // <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'matname',
        header: "Description",
        Cell: ({ cell, row }) => (
          <>
            <p className="product-name">
              <Link to={"/product-detail?matnum=" + cell.getValue()}>{cell.getValue()}</Link>
            </p>
            {/* <Typography variant='h4'>Matnum: {cell.getValue()}</Typography> */}
          </>

        ),
        size: 100,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'contractprice',
        header: "Contract price",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      },
      {
        accessorKey: 'sellingprice',
        header: "Selling Price",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'equals',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
      }
      //end
    ],
    [],
  );

  return (
    <>
      
      <MaterialReactTable
        columns={columns}
        data={data}
        enableColumnActions={false}
        enableGlobalFilter={false}
        enableColumnFilterModes
        initialState={{
          showColumnFilters: true
        }}
        manualFiltering
        manualPagination
        manualSorting
        onColumnFilterFnsChange={setColumnFilterFns}
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        tableInstanceRef={tableInstanceRef}
        rowCount={rowCount}
        state={{
          columnFilters,
          columnFilterFns,
          globalFilter,
          isLoading,
          pagination,
          showAlertBanner: isError,
          showProgressBars: isRefetching,
          sorting,
        }}
        positionActionsColumn="last"
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'Action', //change header text
          },
        }}
        enableRowSelection
        renderTopToolbarCustomActions={({ row, table }) => (
          <Box
            sx={{ display: 'flex', gap: '0.5rem', p: '0.5rem', flexWrap: 'wrap' }}
          >
            <Button
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              // onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
              onClick={() => addNewCartItemsFromList(table.getSelectedRowModel().rows)}
              startIcon={<List />}
              variant="contained"
              color="primary"
            >
              Add to my catalog
            </Button>
          </Box>
        )}
        muiTableHeadCellProps={{
          sx: {
            // fontWeight: 'bold',
            fontSize: '15px',
          },
        }}
        muiTablePaginationProps={{
          sx: {
            fontWeight: 'bold',
            paddingTop: '12px',
            fontSize: '16px',
          },
        }}
        muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
          sx: {
            fontSize: '17px'
          },
        })}
        muiTableHeadCellFilterTextFieldProps={{
          sx: {
            fontWeight: 'bold',
            fontSize: '17px',
          },
        }}
      />

    </>
  );
};

export default CustomTable;
